import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template125: Metro de Londres (Subway.jsx guia-londres). Todo desde backend.
// page.texts[0]=header, [1]=intro, [2]=appsTitle, [3]=appsListHtml, [4]=tipsTitle, [5]=tipsListHtml, [6]=importantBox, [7]=sabiasQueBox
const Template125 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found) return found.src ?? found.url;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const logoImage = page.canvasImages?.find(
		(img) => img.id === "logo",
	)?.imageUrl;
	const introText = page?.texts?.[1]?.content;
	const appsTitle = page?.texts?.[2]?.content;
	const appsListHtml = page?.texts?.[3]?.content;
	const tipsTitle = page?.texts?.[4]?.content;
	const tipsListHtml = page?.texts?.[5]?.content;
	const importantBox = page?.texts?.[6]?.content;
	const sabiasQueBox = page?.texts?.[7]?.content;

	const subwaySticker =
		getImageSrc("metro-main") ||
		getImageSrc("subway") ||
		getCanvasImageUrl("subway-sticker");

	const actualHeaderColor = headerBackgroundColor || "#de5624";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "12px",
		marginTop: 0,
		color: "#de5624",
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 600,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: isSmallScreen ? 66 : 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: 13, color: "#444" }}>
					<Box component="p" sx={p}>
						{introText}
					</Box>
				</Box>
			)}

			{/* Apps que te salvan */}
			{(appsTitle || appsListHtml) && (
				<Box data-block-id="text-2" sx={{ padding: "16px", paddingTop: 0 }}>
					<Box
						sx={{
							backgroundColor: "#f4e4df",
							border: "2px solid #de5624",
							borderRadius: "16px",
							padding: "16px",
							position: "relative",
							boxSizing: "border-box",
							width: "100%",
						}}
					>
						{appsTitle && (
							<Box component="h3" sx={h3}>
								{appsTitle}
							</Box>
						)}
						{appsListHtml && (
							<Box
								sx={{
									paddingLeft: 0,
									margin: 0,
									fontSize: 13,
									"& ul": { paddingLeft: "18px", margin: 0 },
								}}
								dangerouslySetInnerHTML={{ __html: appsListHtml }}
							/>
						)}
					</Box>
				</Box>
			)}

			{/* Consejos rápidos */}
			{(tipsTitle || tipsListHtml) && (
				<Box data-block-id="text-3" sx={{ padding: "0 16px", fontSize: 13, color: "#444" }}>
					{tipsTitle && (
						<Box component="h3" sx={h3}>
							{tipsTitle}
						</Box>
					)}
					{tipsListHtml && (
						<Box
							sx={{
								paddingLeft: 0,
								"& ul": { paddingLeft: "18px" },
							}}
							dangerouslySetInnerHTML={{ __html: tipsListHtml }}
						/>
					)}
				</Box>
			)}

			{importantBox && (
				<Box data-block-id="text-4" sx={{ padding: "0 16px" }}>
					<Box
						sx={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "12px",
							padding: "10px 12px",
							marginTop: "8px",
							fontSize: 12,
							color: "#444",
						}}
					>
						<Box
							component="span"
							dangerouslySetInnerHTML={{ __html: importantBox }}
						/>
					</Box>
				</Box>
			)}

			<Box sx={{ position: "relative", height: 200 }}>
				{subwaySticker && (
					<img
						src={subwaySticker}
						alt=""
						style={{
							width: 110,
							position: "absolute",
							bottom: isSmallScreen ? -200 : 0,
							right: 10,
							marginBottom: isSmallScreen ? 20 : 0,
						}}
					/>
				)}
				{sabiasQueBox && (
					<Box
						data-block-id="text-5"
						sx={{
							position: "absolute",
							top: isSmallScreen ? 10 : 30,
							right: 40,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 0px 16px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 200,
						}}
					>
						<Box
							component="span"
							dangerouslySetInnerHTML={{ __html: sabiasQueBox }}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template125.thumbnail = "/images/template-1.png";

export default Template125;
